import type {
  AdminUser,
  CreateUserInput,
  SiteSettings,
  SiteSettingsInput,
  UpdateUserInput,
} from '@moussenaires/shared';

import { api } from './client.js';

export const adminApi = {
  users: () => api.get<AdminUser[]>('/admin/users'),
  createUser: (input: CreateUserInput) => api.post<AdminUser>('/admin/users', input),
  updateUser: (id: number, input: UpdateUserInput) =>
    api.patch<AdminUser>(`/admin/users/${id}`, input),
  impersonate: (id: number) =>
    api.post<{ token: string; expiresIn: number; user: { username: string } }>(
      `/admin/users/${id}/impersonate`,
    ),
  settings: () => api.get<SiteSettings>('/admin/settings'),
  updateSettings: (input: SiteSettingsInput) => api.patch<SiteSettings>('/admin/settings', input),
};
